gsap.registerPlugin(ScrollTrigger);
var mm = gsap.matchMedia();

mm.add("(min-width: 992px)", function () {
  var resizeTimer;

  function initHighlightSlider() {
    var sliderContainer = document.querySelector('.highlights-section');
    var sliderTrack = document.querySelector('.highlight-slider-track');
    var slides = gsap.utils.toArray('.highlight-slide');

    if (!sliderContainer || !sliderTrack || !slides.length) return;

    // Kill any previous ScrollTriggers for this container
    ScrollTrigger.getAll().forEach(st => {
      if (st.trigger === sliderContainer) st.kill();
    });

    gsap.set(sliderTrack, { x: 0 });

    var gap = 20;
    var containerWidth = sliderContainer.offsetWidth;
    var baseWidth = slides[0].getBoundingClientRect().width;
    var expandedWidth = ((containerWidth - 40) / 3) * 2 + 20;

    function getScrollDistance() {
      var totalWidth = 0;
      slides.forEach((slide, index) => {
        totalWidth += (index === 0 ? expandedWidth : baseWidth) + gap;
      });
      totalWidth -= gap;
      return totalWidth - containerWidth + (expandedWidth - baseWidth) / 2;
    }

    var scrollDistance = getScrollDistance();
    if (scrollDistance <= 0) return;

    var prevArrow = document.querySelector('.highlight-prev');
    var nextArrow = document.querySelector('.highlight-next');

    // Create tween with ScrollTrigger
    var tween = gsap.to(sliderTrack, {
      x: -scrollDistance,
      ease: "none",
      scrollTrigger: {
        trigger: sliderContainer,
        start: "top top+=70",
        end: "+=" + scrollDistance,
        scrub: 0.5,
        pin: true,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: () => {
          updateHighlight();
          updateArrows();
        }
      }
    });

    // Highlight update based on ScrollTrigger progress
    function updateHighlight() {
      var st = ScrollTrigger.getAll().find(
        st => st.trigger && st.trigger.classList.contains('highlights-section')
      );
      if (!st || !st.animation) return;

      var progress = st.progress;
      var index = Math.round(progress * (slides.length - 1));
      slides.forEach(s => s.classList.remove('highlight'));
      if (slides[index]) slides[index].classList.add('highlight');
    }

    function updateArrows() {
      var st = ScrollTrigger.getAll().find(
        st => st.trigger && st.trigger.classList.contains('highlights-section')
      );
      if (!st || !st.animation) return;

      var progress = st.progress;
      var currentIndex = Math.round(progress * (slides.length - 1));

      if (prevArrow) prevArrow.classList.toggle("disabled", currentIndex === 0);
      if (nextArrow) nextArrow.classList.toggle("disabled", currentIndex === slides.length - 1);
    }

    function moveSlide(direction) {
      var st = ScrollTrigger.getAll().find(
        st => st.trigger && st.trigger.classList.contains('highlights-section')
      );
      if (!st || !st.animation) return;

      var progress = st.progress;
      var currentIndex = Math.round(progress * (slides.length - 1));

      if (direction === "next" && currentIndex < slides.length - 1) currentIndex++;
      if (direction === "prev" && currentIndex > 0) currentIndex--;

      var targetProgress = currentIndex / (slides.length - 1);
      var targetScroll = st.start + (st.end - st.start) * targetProgress;

      gsap.to(window, {
        scrollTo: targetScroll,
        duration: 0.8,
        ease: "power2.out"
      });
    }

    if (prevArrow) prevArrow.onclick = () => moveSlide("prev");
    if (nextArrow) nextArrow.onclick = () => moveSlide("next");

    // Initial highlight and arrows
    updateHighlight();
    updateArrows();
  }

  window.addEventListener('load', function () {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initHighlightSlider();

        setTimeout(() => {
          ScrollTrigger.refresh();
          
          // Update highlight after refresh
          var slides = gsap.utils.toArray('.highlight-slide');
          var st = ScrollTrigger.getAll().find(
            st => st.trigger && st.trigger.classList.contains('highlights-section')
          );
          if (st && st.animation) {
            var progress = st.progress;
            var index = Math.round(progress * (slides.length - 1));
            slides.forEach(s => s.classList.remove('highlight'));
            if (slides[index]) slides[index].classList.add('highlight');
          }
        }, 50);
      });
    });
  });

  // Debounced resize
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initHighlightSlider, 300);
  });
});

/* Mobile: Slick fallback */
mm.add("(max-width: 991px)", function () {
  var $track = $('.highlight-slider-track');
  var $prevArrow = $('.highlight-prev');
  var $nextArrow = $('.highlight-next');

  ScrollTrigger.getAll().forEach(st => st.kill());
  gsap.set($track, { clearProps: "all" });

  if ($track.hasClass('slick-initialized')) $track.slick('unslick');

  var $visibleSlides = $track.find('.highlight-slide').filter(':visible');
  var $tempTrack = $('<div class="temp-slick-track"></div>').append($visibleSlides.clone());
  $track.html($tempTrack);

  $tempTrack.on('init reInit afterChange', function (event, slick, currentSlide) {
    var current = currentSlide !== undefined ? currentSlide : 0;
    var lastIndex = slick.slideCount - slick.options.slidesToShow;

    if ($prevArrow.length) $prevArrow.toggleClass('disabled', current <= 0);
    if ($nextArrow.length) $nextArrow.toggleClass('disabled', current >= lastIndex);
  });

  $tempTrack.slick({
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: true,
    prevArrow: $prevArrow,
    nextArrow: $nextArrow,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  });
});